import {
  appsWarehouseApiGetGoodsReceipt,
  appsWarehouseApiListGoodsReceipts,
  getAppsWarehouseApiGetGoodsReceiptQueryKey,
  getAppsWarehouseApiListGoodsReceiptsQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsWarehouseApiListGoodsReceiptsParams } from '@/lib/api/generated/types.ts/appsWarehouseApiListGoodsReceiptsParams'
import type { GoodsReceiptOut } from '@/lib/api/generated/types.ts/goodsReceiptOut'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const goodsReceiptsListQuery = (params?: AppsWarehouseApiListGoodsReceiptsParams) =>
  typedSuspenseOptions<readonly GoodsReceiptOut[]>({
    queryKey: getAppsWarehouseApiListGoodsReceiptsQueryKey(params),
    queryFn: ({ signal }) =>
      appsWarehouseApiListGoodsReceipts(params, { signal }) as unknown as Promise<
        readonly GoodsReceiptOut[]
      >,
    staleTime: 15_000,
  })

export const goodsReceiptDetailQuery = (goodsReceiptId: number) =>
  typedSuspenseOptions<GoodsReceiptOut>({
    queryKey: getAppsWarehouseApiGetGoodsReceiptQueryKey(goodsReceiptId),
    queryFn: ({ signal }) =>
      appsWarehouseApiGetGoodsReceipt(goodsReceiptId, {
        signal,
      }) as unknown as Promise<GoodsReceiptOut>,
    staleTime: 15_000,
    enabled: Number.isFinite(goodsReceiptId) && goodsReceiptId > 0,
  })
